import { Button, X } from '@chain-zen/ui'

interface IModalHeaderProps {
  onClose: () => void
  subtitle?: string
  title: string
}

/**
 * Header component for modal dialogs.
 * Shows title, subtitle, and close button.
 */
export const ModalHeader = ({ onClose, subtitle, title }: IModalHeaderProps) => {
  return (
    <div className="px-5 py-3.5 border-b border-border flex items-center justify-between shrink-0">
      <div>
        <h2 className="text-foreground text-base font-semibold">{title}</h2>
        {!!subtitle && <p className="text-muted-foreground text-xs mt-0.5">{subtitle}</p>}
      </div>
      <Button
        onClick={onClose}
        variant="ghost"
        size="icon"
        className="text-muted-foreground hover:text-foreground hover:bg-accent"
      >
        <X className="w-5 h-5" />
      </Button>
    </div>
  )
}
